module.exports = __webpack_public_path__ + "static/favicon-db2389a6fe7e8842410d288af7b9481c.ico";